module.exports = __webpack_public_path__ + "prize-3.49fa8b69.png";